import { render } from "./Datenschutz.vue?vue&type=template&id=ca62eece&scoped=true"
import script from "./Datenschutz.vue?vue&type=script&lang=js"
export * from "./Datenschutz.vue?vue&type=script&lang=js"

import "./Datenschutz.vue?vue&type=style&index=0&id=ca62eece&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca62eece"]])

export default __exports__